import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { ActivityCalendarService } from './activity-calendar-service/activity-calendar.service';
import { ActivityCalendarComponent } from './activity-calendar/activity-calendar.component';
import { ActivityHistoryDetailComponent } from './activity-history-detail/activity-history-detail.component';
import { ActivitySnippetComponent } from './activity-snippet/activity-snippet.component';
import { CustomDatepickerI18n } from './datepicker-i18n';

@NgModule({
  imports: [NgbModule, CommonModule, FormsModule, SharedModule],
  declarations: [ActivityCalendarComponent, ActivitySnippetComponent, ActivityHistoryDetailComponent],
  exports: [ActivityCalendarComponent],
  providers: [ActivityCalendarService, DatePipe, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}],
})
export class ActivityCalendarModule {}



// WEBPACK FOOTER //
// ./ts/app/activity-calendar/activity-calendar.module.ts